<template>
    <div id="issue-comments" :class="['d-flex w-100 h-100', locationType == 'viewer' && 'is-inside-viewer']">
        <div class="top-drop-shadow w-100"></div>
        <vue-custom-scrollbar v-if="selectedIssue.events.length" class="custom-scroll w-100" ref="scroll">
            <Event
                @onCommentDeleted="deleteComment"
                @onCommentUpdated="updateComment"
                v-for="event in selectedIssue.events"
                :key="event.id"
                :event="event"
                :loggedUser="loggedUser"
            />
        </vue-custom-scrollbar>
        <div v-else class="d-flex justify-content-center align-items-center w-100 h-100">
            <p class="text-12 text-secondary-3 text-center">
                {{ $t('Components_Issues_IssueComments_1') }}
            </p>
        </div>
        <div class="bottom-drop-shadow w-100"></div>
    </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'
import Event from '@/components/Issues/Event'

export default {
    props: {
        selectedIssue: Object,
        loggedUser: Object,
        locationType: String,
    },
    components: {
        VueCustomScrollbar,
        Event,
    },
    watch: {
        'selectedIssue.events': {
            handler() {
                setTimeout(() => {
                    this.scrollBottom('smooth')
                }, 1)
            },
            deep: true,
        },
    },
    methods: {
        // ==================================
        // New methods, change JSON local
        // ==================================
        deleteComment(comment) {
            this.$emit('onIssueCommentDeleted', comment)
        },
        updateComment(comment) {
            this.$emit('onIssueCommentUpdated', comment)
        },
        scrollBottom(scrollBehavior = 'auto') {
            if (this.$refs.scroll) {
                let el = this.$refs.scroll.$el
                el.scrollTo({
                    top: el.scrollHeight,
                    left: 0,
                    behavior: scrollBehavior,
                })
            }
        },
        isCloseToBottom() {
            if (this.$refs.scroll) {
                return this.$refs.scroll.$el.scrollHeight - this.$refs.scroll.$el.scrollTop - this.$refs.scroll.$el.clientHeight < 50
            }
        },
    },
    mounted() {
        this.scrollBottom()
    },
}
</script>

<style lang="scss" scoped>
#issue-comments {
    position: relative;

    &.is-inside-viewer {
        .custom-scroll {
            padding: 8px 0;
        }
    }

    .top-drop-shadow {
        height: 24px;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%);
    }
    .bottom-drop-shadow {
        height: 24px;
        position: absolute;
        top: calc(100% - 24px);
        left: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    }
    .custom-scroll {
        padding: 8px 24px;
    }
}
</style>
